import { Pipe, PipeTransform } from '@angular/core';
import { Resource } from '@klickdata/core/resource';
import { Utils } from '@klickdata/core/util';
import * as moment from 'moment';

@Pipe({
    name: 'resourcePlayableInfo',
})
export class ResourcePlayableInfoPipe implements PipeTransform {
    grey = '#b6b6b6';
    orange = '#ff9961';
    red = '#e44a66';
    white = '#fff';
    darkblue = '#3e5365';
    green = '#bfd8d0';
    iceblue = '#93cbd1';

    transform(resource: Resource): {
        borderColor?: string;
        label: string;
        backgroundColor?: string;
        details?: string;
        disabled?: boolean;
    } {
        const metadata = resource.user_collaboration?.enroll_approval_required?.metadata;
        if (!metadata)
            return {
                borderColor: this.green,
                label: $localize`Open`,
                backgroundColor: this.green,
            };
        // if the resource is pending or rejected
        // if (resource.enrollment.approval_status == 'pending' || resource.enrollment.approval_status == 'rejected') {
        //     return {
        //         borderColor: this.grey,
        //         label: $localize`Not available`,
        //         details:
        //             resource.enrollment.approval_status == 'pending'
        //                 ? $localize`Registration pending.`
        //                 : $localize`Registration rejected.`,
        //         backgroundColor: this.white,
        //         disabled: true,
        //     };
        // }
        // if the resource is always open or has no occasion dates
        if (metadata.occasion_always_open || !metadata.occasion_dates.length || !metadata.occasion_dates) {
            return {
                borderColor: this.green,
                label: $localize`Always open`,
                backgroundColor: this.green,
            };
        }
        // if the resource is during the occasion period
        if (metadata.occasion_dates.length > 0 && Utils.isResourceDuringOccasionPeriod(metadata.occasion_dates)) {
            return {
                borderColor: this.green,
                label: $localize`Open to`,
                details: moment(Utils.getResourceLastOccasion(metadata.occasion_dates).end_date).format('YYYY-MM-DD'),
                backgroundColor: this.green,
            };
        }
        // if the resource is not during the occasion period and has future occasion
        if (
            !Utils.isResourceDuringOccasionPeriod(metadata.occasion_dates) &&
            Utils.isResourceHasFutureOccasion(metadata.occasion_dates)
        ) {
            return {
                borderColor: this.grey,
                label: $localize`Not available`,
                details:
                    $localize`Open` +
                    ' ' +
                    moment(Utils.getResourceLastOccasion(metadata.occasion_dates).end_date).format('YYYY-MM-DD'),
                backgroundColor: this.white,
                disabled: true,
            };
        }
    }
}
